export default ({ fill }) => (
  /**
   * Ícone utilizado para alinhamento do
   * rótulo ao centro horizontal da feição
   */
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9719 7.05339H12.8052V2.88672H10.3052V7.05339H6.97187V0.386719H4.47187V7.05339H0.171875V8.72005H4.47187V15.3867H6.97187V8.72005H10.3052V12.8867H12.8052V8.72005H16.9719V7.05339Z"
      fill={fill || '#797E82'}
    />
  </svg>
);
